import type { DeliveryReasonCode } from "./deliveryCheck";

export type DeliverableSite = {
  siteId: string;
  deliverable: boolean;
  fee: number;
  etaMinutes: number;
  minOrder: number;
  distanceMeters: number;
  reason?: DeliveryReasonCode;
};

export type SiteWithDelivery<T extends { id: string }> = T & {
  delivery?: DeliverableSite;
};

export const mergeDeliverable = <T extends { id: string }>(
  sites: T[],
  results: DeliverableSite[],
): SiteWithDelivery<T>[] => {
  const byId = new Map(results.map((r) => [r.siteId, r]));
  return sites.map((s) => ({ ...s, delivery: byId.get(s.id) }));
};

export const sortForDelivery = <T extends { id: string }>(
  sites: SiteWithDelivery<T>[],
): SiteWithDelivery<T>[] =>
  [...sites].sort((a, b) => {
    const ad = a.delivery?.deliverable ? 0 : 1;
    const bd = b.delivery?.deliverable ? 0 : 1;
    if (ad !== bd) return ad - bd;
    return (a.delivery?.distanceMeters ?? Infinity) - (b.delivery?.distanceMeters ?? Infinity);
  });
